<template>
  <div class="md:hidden">
    <div
      v-for="column in columns"
      :key="column.id"
      class="border-b border-gray-600 last:border-none"
    >
      <!-- If has children, use accordion -->
      <template v-if="column.children.length > 0">
        <Accordion
          :ref="(el) => (accordionRefs[column.id] = el)"
          :title="column.name"
        >
          <ul class="ml-4 mt-1 flex flex-col gap-y-6 pb-4">
            <li v-for="item in column.children" :key="item.id">
              <NuxtLink :to="item.options?.url" class="block text-lg">
                {{ item.name }}
              </NuxtLink>
            </li>
          </ul>
        </Accordion>
      </template>
      <!-- If no children, use simple link with accordion styling -->
      <template v-else>
        <NuxtLink :to="column.options?.url" class="block py-4 text-base">
          <span class="text-lg font-semibold">{{ column.name }}</span>
        </NuxtLink>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineAsyncComponent } from 'vue'
import type { ComponentPublicInstance } from 'vue'
import type { NavigationTreeItem } from '@scayle/storefront-nuxt'
import { useRouter } from '#app/composables/router'
import { NuxtLink } from '#components'

const Accordion = defineAsyncComponent(
  () => import('~/components/ui/Accordion.vue'),
)

defineProps<{
  columns: NavigationTreeItem[]
}>()

interface AccordionInstance extends ComponentPublicInstance {
  reset: () => void
}

const accordionRefs = ref<Record<string, AccordionInstance | null>>({})

// Reset accordions when route changes
useRouter().afterEach(() => {
  Object.values(accordionRefs.value).forEach((accordion) => {
    accordion?.reset()
  })
})
</script>

<script lang="ts">
export default {
  name: 'SFFooterMobileNav',
}
</script>
